import Moment from "moment";

const HDFCQuickReqBody = (data) => {
  console.log("data from submit", data);
  let Date_Of_Birth;
  let dob_year;
  let D_O_B = null   //`01/01/${dob_year}`;
  let isDOB;
  var date2 = Moment();
  let year = date2.format("YYYY");
  var currentDate2 = date2.format("DD/MM/YYYY");
  for (let i = 0; i < data["insureds"].length; i++) {
    Date_Of_Birth = data["insureds"][i]["DOB"];
    console.log("DateOfBirth:", Date_Of_Birth)
    dob_year = year - data["insureds"][i]["Age"];


    if (Date_Of_Birth === "" || Date_Of_Birth === null) {
      D_O_B = `01/01/${dob_year}`
      isDOB = false;
    }
    else if (Date_Of_Birth !== null || Date_Of_Birth !== "") {
      D_O_B = Date_Of_Birth;
      isDOB = true;
    }
    if (!isDOB) return null;

    let age = data["insureds"][i]["Age"];
    if (Number(age) > 45 && (data["insureds"][i]["relationShip"] !== 'Dependent Parent(Father)' && data["insureds"][i]["relationShip"] !== 'Dependent Parent(Mother)' && data["insureds"][i]["relationShip"] !== 'Dependent In Law(Mother)' && data["insureds"][i]["relationShip"] !== 'Dependent In Law(Father)')) {
      console.log("Hdfc req body contains age > 45", age);
      return null;
    }
  }
  let relationship;
  let Plan_Type = "";
  //Married or not
  let Mar_or_not = "";
  let gender = data['gender']
  let rel = "";
  let countAdult = 0;
  let countChild = 0;
  let countParent = 0;
  let Policy_Type = "";
  let Policy_Type2 = ""; //for HF
  let INValues2 = null; //for HF
  let Final = null;
  let INValues = null;

  //TODAY
  data["insureds"].map((item, index) => {
    //console.log(`insured item ${index}`, item)
    /*  let insureObject={
                 name: item.name, 
                 dob: '1990-11-02', 
                 relationshipId: item.relationShip , 
                 sumInsuredId: data
             }; */

    if (item.relationShip === "Dependent Child") {
      countChild++;
    }
    if (item.relationShip === "Dependent Parent(Father)") {
      countParent++;

    }
    if (item.relationShip === "Dependent Parent(Mother)") {
      countParent++;
    }
    if (item.relationShip !== "Dependent Child" && item.relationShip !== "Dependent Parent(Father)" && item.relationShip !== "Dependent Parent(Mother)" && item.relationShip !== "Dependent In Law(Mother)" && item.relationShip !== "Dependent In Law(Father)") {
      countAdult++;
    }
  });
  if (countChild > 0 && countAdult > 0 && countParent === 0) {
    relationship = `${countAdult}A+${countChild}C`;
  }
  else if (countAdult > 1 && countChild > 1 && countParent > 1) {
    relationship = `${countAdult}A+${countChild}C+${countParent}P`;
  }
  else if (countAdult > 1 && countParent > 1) {
    relationship = `${countAdult}A+${countParent}P`;
  }
  else {
    relationship = `${countAdult}A`;
  }
  //console.log('adult and child', countAdult, countChild)
  // console.log('relationship', relationship)

  switch (relationship) {
    case "1A+1C":
      Plan_Type = "1 Adult + 1 Child";
      break;
    case "1A+2C":
      Plan_Type = "1 Adult + 2 Children";
      break;
    case "1A+3C":
      Plan_Type = "1 Adult + 3 Children";
      break;
    case "2A":
      Plan_Type = "2 Adults";
      break;
    case "2A+1C":
      Plan_Type = "2 Adults + 1 Child";
      break;
    case "2A+2C":
      Plan_Type = "2 Adults + 2 Children";
      break;
    case "2A+2P":
      Plan_Type = "2 Adults + 2 Parents";
      break;
    case "2A+2C+2P":
      Plan_Type = "2 Adults + 2 Parents + 2 Children";
      break;
    default:
      Plan_Type = "";
      break;
  }

  //TODAY

  INValues = {
    TransactionID: "",
    Policy_Details: {
      PolicyStartDate: currentDate2,
      ProposalDate: currentDate2,
      Policy_Type: "",
    },
    Req_HI: {
      PropRisks_Plan: "Silver Smart",
      PropRisks_Tier: "",
      POLICY_TENURE: data["period"],
      Insured_Details: [],
    },
  };
  //CURRENT   for HF
  INValues2 = {
    PropRisks_FamilyPolicy: "",
  };

  for (let i = 0; i < data["insureds"].length; i++) {
    let relationShip = data["insureds"][i]["relationShip"]
    if (data["insureds"].length > 1 && relationShip === "Self" || relationShip === "Spouse") {
      Mar_or_not = "Yes";
    } else {
      Mar_or_not = "No";
    }
    if (relationShip === "Spouse" && data['gender'] === "Male") {
      gender = "F";
    } else if (relationShip === "Spouse" && data['gender'] === "Female") {
      gender = "M";
    }
    if (relationShip === "Self") {
      gender = data['gender'].charAt(0);
    }
    //TEMP
    if (data["insureds"].length === 1) {
      Policy_Type = "Individual";
    } else if (data["insureds"].length > 1) {
      INValues2["PropRisks_FamilyPolicy"] = Plan_Type; //for HF
      Policy_Type = "Multi Individual";
      // Policy_Type2="Family Floater";//for HF
    } //TEMP


    INValues["Policy_Details"]["Policy_Type"] = Policy_Type; //TEMP
    // INValues2['Policy_Details']["Policy_Type"]=Policy_Type2;//for HF

    INValues["Req_HI"]["Insured_Details"].push({
      PropRisks_DateOfBirth: data["insureds"][i]["DOB"],
      PropRisks_NameofPerson: data["insureds"][i]["name"],
      PropRisks_Relation: relationShip,
      PropRisks_Gender: gender,
      PropRisks_Dependent: "No",
      PropRisks_MaritalStatus: Mar_or_not,
      PropRisks_SumInsured: data["sumInsuredValue"],
    });
    //FOR HF
    // INValues2['Req_HF']['Insured_Details'].push({
    //     "PropRisks_DateOfBirth": D_O_B,
    //     "PropRisks_NameofPerson": data['insureds'][i]['name'],
    //     "PropRisks_Relation": data['insureds'][i]['relationShip'],
    //     "PropRisks_Gender":"F",
    //     "PropRisks_Dependent":"No",
    //     "PropRisks_MaritalStatus": Mar_or_not,
    //     "PropRisks_SumInsured": data['sumInsuredValue'],
    // })
    var HI;
    HI = { HI: INValues, isDOB: isDOB };
    Final = { isDOB: isDOB, HI: INValues, HF: INValues2 };
  }
  if (data["insureds"].length === 1) {
    return HI;
  } else if (data["insureds"].length > 1 && Plan_Type === "") {
    return HI;
  }
  else {
    return Final
  }
};

export default HDFCQuickReqBody;
